import Cookies from 'js-cookie';

// VIEW TOPIC
const view_topic = async (topic, lang, uid) => {
    try {
        const url = `/api/${topic}/view/${uid}?lang=${lang}`;
        const response = await fetch(url, {
            method: "GET",
            headers: {
                'Authorization':  `Bearer ${Cookies.get('accessToken')}`,
                'Accept': 'application/json',
                'Content-Type': 'application/json'       
            }
        });
        const result = await response.json();
        if (result) {
            return [response.status, result];
        } else {
            return [500, null];
        }
    } catch (error) {
        return [500, null];
    }
}

export const view_wazaren = async (lang, uid) => {
    const result = await view_topic("wazaren", lang, uid);
    return result;
}

export const view_wotageishi = async (lang, uid) => {
    const result = await view_topic("wotageishi", lang, uid);
    return result;
}

export const view_organization = async (lang, uid) => {
    const result = await view_topic("organization", lang, uid);
    return result;
}

export const view_place = async (lang, uid) => {
    const result = await view_topic("place", lang, uid);
    return result;
}


// VIEW TOPICS
const view_topics = async (topic, lang, searchParams) => {
    try {
        const url = `/api/${topic}/view/?lang=${lang}&${searchParams.toString()}`;
        const response = await fetch(url, {
            method: "GET",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'       
            }
        });
        const result = await response.json();
        if (result) {
            return [response.status, result];
        } else {
            return [500, null];
        }
    } catch (error) {
        return [500, null];
    }
}

export const view_wazarens = async (lang, searchParams) => {
    const result = await view_topics("wazaren", lang, searchParams);
    return result;
}

export const view_wotageishis = async (lang, searchParams) => {
    const result = await view_topics("wotageishi", lang, searchParams);
    return result;
}

export const view_organizations = async (lang, searchParams) => {
    const result = await view_topics("organization", lang, searchParams);
    return result;
}

export const view_places = async (lang, searchParams) => {
    const result = await view_topics("place", lang, searchParams);
    return result;
}

export const view_movements = async (lang, searchParams) => {
    const result = await view_topics("movement", lang, searchParams);
    return result;
}

// VIEW TOPIC NAME LIST
const view_topic_namelist = async (topic, lang, name) => {
    try {
        const url = `/api/${topic}/view/name_list/?lang=${lang}&name=${name}`;
        const response = await fetch(url, {
            method: "GET",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'       
            }
        });
        const result = await response.json();
        if (result) {
            return [response.status, result];
        } else {
            return [500, null];
        }
    } catch (error) {
        return [500, null];
    }
}

export const view_wazaren_namelist = async (lang, name) => {
    const result = await view_topic_namelist("wazaren", lang, name);
    return result;
}

export const view_wotageishi_namelist = async (lang, name) => {
    const result = await view_topic_namelist("wotageishi", lang, name);
    return result;
}

export const view_organization_namelist = async (lang, name) => {
    const result = await view_topic_namelist("organization", lang, name);
    return result;
}

export const view_place_namelist = async (lang, name) => {
    const result = await view_topic_namelist("place", lang, name);
    return result;
}

// VIEW TOPIC's UPDATE REQUEST
const import_topic_data = async (topic, lang, uid) => {
    try {
        const url = `/api/${topic}/view/update_request/${uid}?lang=${lang}`;
        const response = await fetch(url, {
            method: "GET",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'       
            }
        });
        const result = await response.json();
        if (result) {
            return [response.status, result];
        } else {
            return [500, null];
        }
    } catch (error) {
        return [500, null];
    }
}

export const import_wazaren_data = async (lang, uid) => {
    const result = await import_topic_data("wazaren", lang, uid);
    return result;
}

export const import_wotageishi_data = async (lang, uid) => {
    const result = await import_topic_data("wotageishi", lang, uid);
    return result;
}

export const import_organization_data = async (lang, uid) => {
    const result = await import_topic_data("organization", lang, uid);
    return result;
}

export const import_place_data = async (lang, uid) => {
    const result = await import_topic_data("place", lang, uid);
    return result;
}




